import { api } from '../../common/api/httpClient';
import type { PortalBootstrap } from '../../model/portalModels';

export const portalApi = {
  bootstrap() {
    return api<PortalBootstrap>('/api/portal/bootstrap');
  },
};
